import { useTranslation } from 'react-i18next';
import { Button } from '@treezor/design-system';

import { useCreatePasskey } from '../hooks/useCreatePasskey';

export function Auth2FaRegistration() {
  const { t } = useTranslation();
  const { register2Fa, isLoading } = useCreatePasskey();

  return (
    <div className="flex flex-col gap-6">
      <span className="typo-body-regular-paragraphLarge text-primary">{t('pages.auth.2fa.creationDescription')}</span>
      <Button onClick={register2Fa} isLoading={isLoading} className="w-fit">
        {t('pages.auth.2fa.enable2Fa')}
      </Button>
    </div>
  );
}
